<template>
  <div
    :class="[
      'my-gift-tab-loader-container cell small-12 medium-12 large-12 xlarge-12',
      'medium-margin-top-xl small-margin-top-m medium-margin-bottom-xl small-margin-bottom-m',
    ]"
  >
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-12">
        <AtomicUiSkeleton height="22px" width="144px" />
      </div>
    </div>
    <div class="grid-x grid-margin-x medium-margin-top-s small-margin-top-xs">
      <div class="cell small-12 medium-9 grid-x hide-for-small-only">
        <AtomicUiSkeleton height="48px" width="120px" />
        <AtomicUiSkeleton height="48px" width="106px" class="margin-left-xs" />
        <AtomicUiSkeleton height="48px" width="112px" class="margin-left-xs" />
      </div>
      <div class="cell small-12 medium-3 hide-for-small-only">
        <AtomicUiSkeleton height="48px" width="100%" />
      </div>
      <div class="cell small-12 medium-3 show-for-small-only d-flex">
        <AtomicUiSkeleton height="48px" width="26%" />
        <AtomicUiSkeleton height="48px" width="23%" class="margin-left-xs" />
        <AtomicUiSkeleton height="48px" width="18%" class="margin-left-xs" />
        <AtomicUiSkeleton height="48px" width="16%" class="margin-left-xs" />
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div v-for="product in 4" :key="product" class="cell large-3 small-6 margin-top-xl">
        <div class="product-card grid-y">
          <AtomicUiSkeleton height="255px" />
          <div v-for="items in 3" :key="items">
            <AtomicUiSkeleton class="margin-top-xxs" height="20px" width="60%" />
          </div>
          <AtomicUiSkeleton class="margin-top-l" height="20px" width="80%" />
          <div class="grid-margin-y grid-x">
            <div class="cell large-11">
              <div class="grid-x grid-margin-y">
                <div class="cell large-5">
                  <AtomicUiSkeleton class="margin-top-s" height="50px" />
                </div>
                <div class="cell large-5">
                  <AtomicUiSkeleton class="medium-margin-top-s large-margin-left-s" height="50px" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.d-flex {
  display: flex;
}
</style>
